export const SEND_PAYMENT_ERROR_COLOR = '#E92C2C';
